// React Imports
import React from "react";
import { BrowserRouter, MemoryRouter, Switch, Route } from "react-router-dom";

// i18n
import { Translate } from "react-redux-i18n";

// Local project components
import Header from "./global/Header";
//import AdobeIMS from './AdobeIMS/AdobeIMS';
import AdobeIMSV2 from "./AdobeIMS/AdobeIMSV2";
import Footer from "./global/Footer";
import Init from "./pages/Init";
import ErrorDialog from "./global/ErrorDialog";
import PersonalInformation from "./pages/PersonalInformation";

// Pages
import CompanySearchPublic from "./pages/CompanySearchPublic";
import CompanySelect from "./pages/CompanySelect";
import ErrorGeneral from "./pages/error/ErrorGeneral";
import ErrorContactExists from "./pages/error/ErrorContactExists";
import ErrorNoContactExists from "./pages/error/ErrorNoContactExists";
import ErrorBannedDomain from "./pages/error/ErrorBannedDomain";
import ErrorAlreadyRegistered from "./pages/error/ErrorAlreadyRegistered";
import BlankLoader from "./pages/error/BlankLoader";
import ErrorNonPartnerAccount from "./pages/error/ErrorNonPartnerAccount";
import ErrorContactRejected from "./pages/error/ErrorContactRejected";
import Admin from "./pages/Admin";
import ThankYouCorporate from "./pages/ThankYouCorporate";
import ThankYouPublic from "./pages/ThankYouPublic";
import RegApp from "../registration/regApp";
import MPApp from "../managepartnership/MPApp";
import Specialization from "../specialization/Specialization";

import ContactRedirectHandler from "./pages/ContactRedirectHandler";
import { handleChannelPartnersUrlRedirection } from "../utils/channelPartnersRedirect";

// Styles
import "./css/App.scss";
import "./css/OneTrust.scss";
import RenewalApp from "../uplevel_renewal/renewalApp";
import UplevelApp from "../uplevel_renewal/uplevelApp";
import ApprovedContact from "./pages/RedirectSections/ApprovedContact";

function ContactRegistration() {
  return (
    <MemoryRouter>
      <Switch>
        {/* Error Pages */}
        <Route exact path="/" component={Init} />
        <Route
          exact
          path="/error_contact_exists"
          component={ErrorContactExists}
        />
        <Route
          exact
          path="/error_no_contact_exists"
          component={ErrorNoContactExists}
        />
        <Route
          exact
          path="/error_banned_domain"
          component={ErrorBannedDomain}
        />
        <Route exact path="/error_already_registered" component={BlankLoader} />
        <Route exact path="/error_general" component={ErrorGeneral} />
        <Route
          exact
          path="/error_non_partner_account"
          component={ErrorNonPartnerAccount}
        />
        <Route
          exact
          path="/error_contact_rejected"
          component={ErrorContactRejected}
        />

        {/* Find Company */}
        <Route
          exact
          path="/company_search_public"
          component={CompanySearchPublic}
        />
        <Route exact path="/company_select" component={CompanySelect} />

        {/* Personal Information */}
        <Route
          exact
          path="/personal_information"
          component={PersonalInformation}
        />

        {/* Confirmation Pages */}
        <Route exact path="/thank_you_public" component={ThankYouPublic} />
        <Route exact path="/thank_you" component={ThankYouCorporate} />

        {/* Admin Approval */}
        <Route exact path="/admin" component={Admin} />
      </Switch>
    </MemoryRouter>
  );
}

function NonContactRegistration() {
  return (
    <MemoryRouter>
      <Switch>
        <Route exact path="/" component={Init} />
        {/* APC Registration */}
        <Route exact path="/registration" render={() => <RegApp />} />
        {/* APC Uplevel/Renewal */}
        <Route exact path="/uplevel" render={() => <UplevelApp />} />
        <Route exact path="/renewal" render={() => <RenewalApp />} />
        <Route exact path="/manageprofile" component={MPApp} />
        <Route exact path="/specialization" component={Specialization} />

        {/* Admin Approval - for backward compatibility - can be removed after few weeks*/}
        <Route exact path="/admin" component={Admin} />
      </Switch>
    </MemoryRouter>
  );
}

function App() {
  if (handleChannelPartnersUrlRedirection()) {
    // Navigation is already in flight; render nothing so IMS/profile init
    // and the rest of the app don't run needlessly before it completes.
    return null;
  }

  // let urlParams = new URLSearchParams(window.location.search);
  // urlParams.get('appid');
  let a = window.location.pathname;
  a = a.lastIndexOf("/") + 1 === a.length ? a.substring(0, a.length - 1) : a;
  let basePath = a.substring(0, a.lastIndexOf("/"));

  // Added
  const isContactRedirectionUrl =
    window.location?.href?.includes("redirectToApprovedContact=true") ||
    window?.location?.pathname?.includes("/approvedContact");

  return (
    <div>
      <BrowserRouter>
        {/* Render header component for every route. */}
        {!isContactRedirectionUrl && (
          <Route path="/">
            <Header
              data-test-id="global-header"
              includeAdobeLogo
              imsComponent={<AdobeIMSV2 mandatorySignIn susiLocale="en_US" />}
            >
              <Translate
                className="bold-prefix"
                value="global.header.app_prefix_bold"
              />
              <Translate className="text" value="global.header.app_name" />
            </Header>
          </Route>
        )}

        {isContactRedirectionUrl && (
          <Route path="/">
            <Header
              data-test-id="global-header"
              includeAdobeLogo
              className="modified-header"
              imsComponent={<AdobeIMSV2 mandatorySignIn susiLocale="en_US" />}
              hideImsComponent={true}
            >
              <span className="text-container">
                <span className="primary-text">
                  <Translate
                    className="bold-prefix"
                    value="global.header.app_prefix_bold_contact_approved"
                  />
                </span>
                <span className="secondary-text">
                  <Translate
                    className="text"
                    value="global.header.app_name_contact_approved"
                    style={{ marginLeft: "0px" }}
                  />
                </span>
              </span>
            </Header>
          </Route>
        )}

        <ContactRedirectHandler />

        {/* Workflow routes */}
        <Switch>
          <Route
            exact
            path={basePath + "/approvedContact"}
            component={ApprovedContact}
          />

          {/* APC Contact Registration */}
          <Route
            exact
            path={basePath + "/contactreg"}
            component={ContactRegistration}
          />

          <Route
            exact
            path={basePath + "/:anypath"}
            component={NonContactRegistration}
          />

          {/* App Initialization */}
          <Route exact path="/" component={ContactRegistration} />
        </Switch>

        {/* Render footer component at bottom for every route. */}
        <Route path="/" component={Footer} />

        {/* Make error component available for every route. */}
        <Route path="/" component={ErrorDialog} />
      </BrowserRouter>
    </div>
  );
}
export default App;
